<script setup lang="ts">
import type { FatalError } from '~/types'
import type { IconNames } from '~/enums/icons/whitelisted'
import { useI18nSafeFormat } from '~/composables/useI18nSafeFormat'
import { useClearCache } from '~/composables/useClearCache'

defineProps<FatalError & { icon?: IconNames }>()

const { formatDate } = useI18nSafeFormat()
const { clearCache } = useClearCache()

const errorTs = new Date()
</script>

<template>
  <section
    class="flex flex-col gap-y-4 items-center justify-center w-full h-full px-4 py-8 text-center"
    data-testid="error-component"
  >
    <p class="text-primary text-base lg:text-xl font-semibold">
      {{ headline }}
    </p>
    <h1 class="text-xl lg:text-2xl font-medium text-highlighted max-w-md">
      {{ title }}
    </h1>
    <p class="text-sm lg:text-base text-muted max-w-lg">
      {{ description }}
    </p>
    <div v-show="links?.length" class="flex flex-col xs:flex-row gap-4 text-center items-center max-w-96">
      <UButton
        v-for="(link, index) in links" :key="link.label" v-bind="link"
        :data-testid="`error-cta-${index + 1}`"
        @click="link.onClick ? link.onClick() : null"
      />
    </div>
    <UButton
      variant="ghost"
      color="neutral"
      size="sm"
      data-testid="clear-cache-button"
      @click="clearCache"
    >
      {{ $t('generics.clear-cache') }}
    </UButton>
    <span class="text-sm text-muted font-normal">{{ formatDate(errorTs, 'DD.MM.YYYY | h:mm a') }}</span>
  </section>
</template>
